import { List, Map } from 'immutable';

import * as types from './types';
import { types as teamTypes } from './../teams';
import { types as usersTypes } from './../users';


const initialState = Map({
  status: List(),
  teams: List(),
  roles: List(),
});


const filtersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case teamTypes.TEAM_CREATE.SUCCESS: {
      const teams = state.get('teams');
      const newTeam = {
        user_count: 0,
        label: payload.name,
        value: `${payload.id}`,
      };
      return state.set('teams', teams.push(newTeam));
    }
    case teamTypes.TEAM_REMOVE.SUCCESS: {
      const teams = state.get('teams');
      const teamToRemoveIndex = teams.findIndex((team) => team.value === `${payload}`);
      return state.set('teams', teams.delete(teamToRemoveIndex));
    }
    case types.FILTERS_GET.SUCCESS: {
      return state.withMutations((mutable) => {
        mutable.set('status', payload.status);
        mutable.set('teams', List(payload.teams));
        mutable.set('roles', payload.roles);
      });
    }
    case usersTypes.MEMBERSHIP_REMOVE.SUCCESS: {
      return state.withMutations((mutable) => {
        const index = mutable
          .get('teams')
          .findIndex((team) => team.value === `${payload.team}`);
        mutable.updateIn(
          ['teams', index],
          (team) => ({
            ...team,
            user_count: team.user_count - 1,
          }),
        );
      });
    }
    default:
      return state;
  }
};

export default filtersReducer;
